import './Footer.css';
import Logo from '../../assets/img/common/logo.png';
import { useNavigate } from 'react-router-dom';
import { updatePaymentState } from '../../reduxstate/slices/portalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Cookies } from 'react-cookie';
import { getDomain } from '../../shared';
import { RootState } from '../../reduxstate';

const Footer: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { sysPref } = useSelector((state: RootState) => state.portal);
	const { CORPORATE_HEADQUARTERS, CORPORATE_CONTACT_NO } = sysPref;
	const corporateHeadquarters = CORPORATE_HEADQUARTERS ? CORPORATE_HEADQUARTERS : 'AlphaPrep, LLC';
	const handleMakePayment = () => {
		dispatch(updatePaymentState({ isError: false, responseMessage: '' }));
		// sessionStorage.setItem('payment_source_from', 'portal');
		const cookies = new Cookies();
		const domain = getDomain();
		cookies.remove('payment_source_from');
		cookies.set('payment_source_from', 'portal', domain);
		navigate('/makePayment');
	};
	return (
		/* eslint-disable jsx-a11y/anchor-is-valid */
		<div className='footerContainer'>
			<div className='logo'>
				<img src={Logo} alt='Logo' />
			</div>
			<div className='footerLinks'>
				<a href='/privacy-policy'>Privacy Policy</a> |<a href='mailto:info@alphaprep.com'>Contact Us</a> |
				<a style={{ cursor: 'pointer' }} onClick={handleMakePayment}>
					Make a Payment
				</a>{' '}
				|<a href='/employment-opportunities'>Employment Opportunities</a>
				{/* <a href="#">Sitemap</a> */}
			</div>
			<div className='footerInfo'>
				Corporate Headquarters: {corporateHeadquarters}
				{CORPORATE_CONTACT_NO ? ', ' : ''}
				{CORPORATE_CONTACT_NO}
			</div>
		</div>
	);
};

export default Footer;
